function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import ConfigurationManager from './configuration-manager';
import CheckUtils from '../utilities/check-utils';
var SessionStorageMgr = /*#__PURE__*/function () {
  function SessionStorageMgr() {
    _classCallCheck(this, SessionStorageMgr);
    this.storage = window.sessionStorage;
    this.allowedTimeCodes = ['millisecond', 'milliseconds', 'ms', 'second', 'seconds', 's', 'minute', 'minutes', 'm', 'hour', 'hours', 'h', 'day', 'days', 'd', 'week', 'weeks', 'w', 'month', 'months', 'M', 'quarters', 'quarters', 'Q', 'year', 'years', 'y', 'sessionend', 'eos', 'dayend', 'eod'];
  }

  /**
   * sets an expiration date/time for data in the session storage
   *
   * @param ttl {string} - e.g. 7d, eod, 1m - default is eos - End Of Session
   * @returns {number|moment.Moment}
   */
  return _createClass(SessionStorageMgr, [{
    key: "setExpirationDate",
    value: function setExpirationDate() {
      var ttl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'eos';
      // do some wibbly wobbly timey wimey stuff here.

      if (ttl.toLowerCase() !== 'eos' || ttl.toLowerCase() !== 'sessionend') {
        var regexp = /^([0-9]*)([a-zA-z]+)$/;
        var howLong = ttl.match(regexp);
        if (howLong) {
          var numOfX = howLong[1];
          var lengthOfTime = howLong[2];
          if (!this.allowedTimeCodes.includes(lengthOfTime)) {
            console.error("Time code ".concat(lengthOfTime, " is not valid, expiration date/time will be set to immediately expire"));
          }
          if (lengthOfTime.toLowerCase() === 'eod' || lengthOfTime.toLowerCase() === 'dayend') {
            return moment().endOf('day');
          }

          // moment smart enough to translate m, month, and months
          return moment().add(numOfX, lengthOfTime);
        }
      }
      return -1; // couldn't format date.  return default.
    }

    /**
     * sets our data to the session storage object.  We can customize how long the data lives inside the session
     * object by setting an expiration date
     *
     * @param key
     * @param data
     * @param expiration
     */
  }, {
    key: "setData",
    value: function setData(key, data, expiration) {
      var hashKey = this.getCurrentABSHashKey(key);
      var dataObject = {
        expires: this.setExpirationDate(expiration),
        data: data,
        hash: hashKey
      };
      this.storage.setItem(hashKey, JSON.stringify(dataObject));
    }

    /**
     * Retrieves our data from the session storage object.  If it has expired, it is removed and a null value is returned.
     *
     * @param key
     * @returns {string|null}
     */
  }, {
    key: "getData",
    value: function getData(key) {
      var hashKey = this.getCurrentABSHashKey(key);
      var storageItem = JSON.parse(this.storage.getItem(hashKey));
      if (storageItem !== null) {
        var isExpired = this.checkExpiration(storageItem);
        if (!isExpired) {
          return storageItem;
        }

        // item is expired remove from session storage and return null value
        this.removeData(hashKey);
      }
      return null;
    }

    /**
     * Checks if the current item's expiration date has lapsed.  If it is still valid, returns true otherwise returns false.
     *
     * @param item
     * @returns {boolean}
     */
  }, {
    key: "checkExpiration",
    value: function checkExpiration(item) {
      return item.expires !== -1 && moment().isSameOrAfter(item.expires);
    }

    /**
     * Removes the data from our session storage object
     *
     * @param key
     */
  }, {
    key: "removeData",
    value: function removeData(key) {
      this.storage.removeItem(key);
    }
  }, {
    key: "hasData",
    value: function hasData(key) {
      return !CheckUtils.isNullOrEmptyObject(this.getData(key));
    }

    /**
     * creates a unique key for the currently used account/BT/ST combo.  Allows us to store data for more than one account.
     *
     * @param key
     * @returns {string}
     */
  }, {
    key: "getCurrentABSHashKey",
    value: function getCurrentABSHashKey(key) {
      var token = ConfigurationManager.getTokenDetails();
      return "".concat(key, "-").concat(token.DefaultAccountId, "-").concat(token.defaultBillToId, "-").concat(token.defaultSellToId);
    }
  }]);
}();
var SessionStorageManager = new SessionStorageMgr();
export default SessionStorageManager;